import baseApi from "./baseApi";
import axios from "axios";



const getAnnouncements = () => axios.get("Announcement/Announcements", { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const getAnnouncement = (r) => axios.get("Announcement/" + r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });


export default {
    getAnnouncements,
    getAnnouncement
};